// device maps
const iosDeviceMapping = new Map([
  ['320x480', 'iPhone 4S, 4, 3GS, 3G, 1st gen'],
  ['320x568', 'iPhone 5, SE 1st Gen,5C, 5S'],
  ['375x667', 'iPhone SE 2nd Gen, 6, 6S, 7, 8'],
  ['375x812', 'iPhone X, XS, 11 Pro, 12 Mini, 13 Mini'],
  ['390x844', 'iPhone 13, 13 Pro, 12, 12 Pro'],
  ['414x736', 'iPhone 8+'],
  ['414x896', 'iPhone 11, XR, XS Max, 11 Pro Max'],
  ['428x926', 'iPhone 13 Pro Max, 12 Pro Max'],
  ['476x847', 'iPhone 7+, 6+, 6S+'],
  ['744x1133', 'iPad Mini 6th Gen'],
  [
    '768x1024',
    'iPad Mini (5th Gen), iPad (1-6th Gen), iPad Pro (1st Gen 9.7), iPad Mini (1-4), iPad Air(1-2)  '
  ],
  ['810x1080', 'iPad 7-9th Gen'],
  ['820x1180', 'iPad Air (4th gen)'],
  ['834x1194', 'iPad Pro (3-5th Gen 11)'],
  ['834x1112', 'iPad Air (3rd gen), iPad Pro (2nd gen 10.5)'],
  ['1024x1366', 'iPad Pro (1-5th Gen 12.9)']
])

const desktopDeviceMapping = new Map([
  ['Win32', 'Windows'],
  ['Linux', 'Linux'],
  ['MacIntel', 'Mac OS']
])

// get device name for android
const getAndroidDeviceName = () => {
  const androidUserAgentString = window.navigator.userAgent.slice(
    window.navigator.userAgent.indexOf('Android')
  )
  const androidDeviceName = androidUserAgentString.slice(
    androidUserAgentString.indexOf('; ') + 1,
    androidUserAgentString.indexOf(')')
  )
  if (androidDeviceName) {
    return androidDeviceName.trim().split(' ')[0]
  }

  return 'Android'
}

// get device name for ios
const getIosDeviceName = () => {
  const height = window.screen.height
  const width = window.screen.width
  const screenResolution = `${width}x${height}`
  const device = iosDeviceMapping.get(screenResolution)
  if (device) {
    return device
  }
  return 'iPhone'
}

// get device name for desktop
const getDesktopDeviceName = () => {
  const platform = /*navigator?.userAgentData?.platform || */ navigator?.platform || 'unknown'
  const device = desktopDeviceMapping.get(platform) ?? 'Unknown'
  return device
}

// get device name utility
export function getDeviceName(): string {
  let device = ''

  // check if mobile device
  const isMobileDevice = window.navigator.userAgent.toLowerCase().includes('mobi')

  if (isMobileDevice) {
    if (window.navigator.userAgent.includes('Android')) {
      device = getAndroidDeviceName()
    } else {
      device = getIosDeviceName()
    }
  } else {
    device = getDesktopDeviceName()
  }

  return device
}

export function getDeviceOrientation() {
  const orientation = (window.screen.orientation || {}).type

  switch (orientation) {
    case 'portrait-primary':
    case 'portrait-secondary':
      return 'portrait'

    case 'landscape-primary':
    case 'landscape-secondary':
      return 'landscape'

    default:
      return 'portrait'
  }
}

export function isOrientationPortrait() {
  return getDeviceOrientation() === 'portrait'
}

export function isOrientationLandscape() {
  return getDeviceOrientation() === 'landscape'
}

export function addOrientationChangeListener(callback: (event: Event) => void) {
  window.addEventListener('orientationchange', callback)
}

export function removeOrientationChangeListener(callback: (event: Event) => void) {
  window.removeEventListener('orientationchange', callback)
}
